import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { environment } from "src/environments/environment";
@Injectable({
    providedIn: 'root'
  })
export class AuthReserva implements CanActivate {
    constructor(private router: Router){}
    canActivate(): boolean  {
       var respuesta:boolean = false;
        try{
            let reservaInfo =JSON.parse(atob(localStorage.getItem(environment.zc)));
            respuesta=true;
       }
       catch(e){

       }
       
       if(!respuesta){
        this.router.navigate(['/']);
       }
       return respuesta;
    }

}
